export const GET_EMPLOYEE_CLASSIFICATIONS = 'GET_EMPLOYEE_CLASSIFICATIONS';
export const UNATORIZED = 'UNATORIZED';
export const ERROR_EMPLOYEE_CLASSIFICATIONS = 'ERROR_EMPLOYEE_CLASSIFICATION';